import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { BetEventModel } from '@shared/types';

import { useUpdateBetEventMutation } from '@services';

import { AppDispatch, updateBetEvent } from '@store';

import { BetEventForm, BetEventFormValues } from '../../../BetSystemSettingsForms';

import { BetEventEditModalProps } from './types';
import { getBetEventFormValuesFromModel } from './utils';

export const BetEventEditModal: FC<BetEventEditModalProps> = ({ isOpened, handleClose, betEvent }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [updateBetEventById, { isLoading: isUpdateInProgress }] = useUpdateBetEventMutation();

  const handleUpdateBetEvent = async (values: BetEventFormValues) => {
    const { startDate, ...restValues } = values;

    const updatedBetEvent = await updateBetEventById({
      payload: { ...restValues, startDate: startDate.format() } as Omit<BetEventModel, 'status'>,
      betEventId: betEvent.id,
    }).unwrap();

    dispatch(updateBetEvent(updatedBetEvent));

    toast.success('Success: Bet event has been updated!');

    handleClose();
  };

  const initialValues = getBetEventFormValuesFromModel(betEvent);

  return (
    <BaseModal headerTitle="Edit Event" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <BetEventForm
        submitButtonCaption="Edit"
        initialValues={initialValues}
        isSubmitting={isUpdateInProgress}
        onSubmit={handleUpdateBetEvent}
      />
    </BaseModal>
  );
};
